/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deleteAccountRequestSchema } from "./deleteAccountRequestSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const userDeleteCreateStatus200Schema = z.any();

export const userDeleteCreateStatus400Schema = errorResponseSchema;

export const userDeleteCreateStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userDeleteCreateStatus503Schema = errorResponseSchema;

export const userDeleteCreateResponseSchema = z.union([
	userDeleteCreateStatus200Schema,
	userDeleteCreateStatus400Schema,
	userDeleteCreateStatus401Schema,
	userDeleteCreateStatus503Schema,
]);

export const userDeleteCreateDataSchemaJson = deleteAccountRequestSchema.describe("Сериализатор удаления учётки.");

export const userDeleteCreateDataSchemaXml = deleteAccountRequestSchema.describe("Сериализатор удаления учётки.");

export const userDeleteCreateDataSchema = z.union([userDeleteCreateDataSchemaJson, userDeleteCreateDataSchemaXml]);
